import SliderSponsor from "../Allsponsors.svg"
import SliderPage from "../../components/Home/Sliderpage"

function ReviewSlider() {
    return (
        <>

            <div className="coverofreviewslider">
                <div className="coverofsponer4">
                    <div className="courseltitle" style={{ display: "flex", justifyContent: "center",width:"254px",textAlign:"center",margin:"auto" }}>
                    Empresas con las que trabajamos
                    </div>
                    <div className="descofpartner">
                        <div className="inercon">
                        Estudiantes que se graduaron con nosotros están trabajando en estas empresas.

                        </div>
                    </div>
                    <div style={{ display: "flex", justifyContent: "center" }}>
                        <img className="sponsorimage" src={SliderSponsor} alt="Sponsor" />

                    </div>

                </div>
                <div className="coverofcourselreview">
                 <SliderPage/>
                </div>

                <div className="coverofsponer3" style={{ marginTop: "136px" }} >
                    <div className="courseltitle" >
                    Este curso incluye
                    </div>
                    <div className="listcom">
                        <div>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                <path d="M8 11C10.7614 11 13 8.76142 13 6C13 3.23858 10.7614 1 8 1C5.23858 1 3 3.23858 3 6C3 8.76142 5.23858 11 8 11Z" stroke="#2C292A" stroke-opacity="0.7" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M8 9C9.65685 9 11 7.65685 11 6C11 4.34315 9.65685 3 8 3C6.34315 3 5 4.34315 5 6C5 7.65685 6.34315 9 8 9Z" stroke="#2C292A" stroke-opacity="0.7" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M11 10V15L8 13.5L5 15V10" stroke="#2C292A" stroke-opacity="0.7" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>

                        <span>Carga instantánea al FMCSA</span>
                    </div>
                    <div className="listcom">
                        <div>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                <path d="M13 2.5H3C2.72386 2.5 2.5 2.72386 2.5 3V13C2.5 13.2761 2.72386 13.5 3 13.5H13C13.2761 13.5 13.5 13.2761 13.5 13V3C13.5 2.72386 13.2761 2.5 13 2.5Z" stroke="#2C292A" stroke-opacity="0.7" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M11 1.5V3.5" stroke="#2C292A" stroke-opacity="0.7" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M5 1.5V3.5" stroke="#2C292A" stroke-opacity="0.7" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M2.5 5.5H13.5" stroke="#2C292A" stroke-opacity="0.7" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>

                        <span>Acceso ilimitado al curso.</span>

                    </div>
                    <div className="listcom">
                        <div>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                <path d="M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14Z" stroke="#2C292A" stroke-opacity="0.7" stroke-miterlimit="10" />
                                <path d="M2 8H14" stroke="#2C292A" stroke-opacity="0.7" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M8 13.8371C9.38071 13.8371 10.5 11.2236 10.5 7.99961C10.5 4.77565 9.38071 2.16211 8 2.16211C6.61929 2.16211 5.5 4.77565 5.5 7.99961C5.5 11.2236 6.61929 13.8371 8 13.8371Z" stroke="#2C292A" stroke-opacity="0.7" stroke-miterlimit="10" />
                            </svg>
                        </div>

                        <span>Varios idiomas disponibles para <br></br>un aprendizaje mejorado</span>
                    </div>
                    <div className="listcom">
                        <div>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                <path d="M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14Z" stroke="#6B6969" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M5.75 7.5C6.16421 7.5 6.5 7.16421 6.5 6.75C6.5 6.33579 6.16421 6 5.75 6C5.33579 6 5 6.33579 5 6.75C5 7.16421 5.33579 7.5 5.75 7.5Z" fill="#6B6969" />
                                <path d="M10.25 7.5C10.6642 7.5 11 7.16421 11 6.75C11 6.33579 10.6642 6 10.25 6C9.83579 6 9.5 6.33579 9.5 6.75C9.5 7.16421 9.83579 7.5 10.25 7.5Z" fill="#6B6969" />
                                <path d="M10.5999 9.5C10.3356 9.95537 9.9563 10.3333 9.50001 10.5961C9.04372 10.8588 8.52643 10.9971 7.9999 10.9971C7.47338 10.9971 6.95608 10.8588 6.49979 10.5961C6.0435 10.3333 5.66422 9.95537 5.3999 9.5" stroke="#6B6969" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>

                        <span>Pase su CDL rápidamente <br></br> ¡GARANTIZADO!</span>
                    </div>


                </div>
            </div>

        </>
    )
}
export default ReviewSlider